import { Injectable } from '@angular/core';
import { HttpUtils } from '../../../common/http/http-utils';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { HttpClient } from '@angular/common/http';
let $ = require('jquery');

export class ExternalNetwork {
  'name': string;
  'objectId': string;
  'freeIpCount':  number;
  'availableVdcs': string[];
}

@Injectable()
export class Service {
  value = '';
  private _externalNetworks$: Subject<ExternalNetwork[]>;
  private dataStore: {
    externalNetworks: ExternalNetwork[]
  };

  constructor(public http: HttpClient) {
    this._externalNetworks$ = <Subject<ExternalNetwork[]>>new Subject();
    this.dataStore = {
      externalNetworks: []
    };
  }

  getDirectConnectList() {
    return this.http
    .get(HttpUtils.getBaseUrl() + '/hybridity/api/directConnects')
    .map(
        (res: any) => this.value = res
      );
  }


  getDirectConnect() {
    return this.http
    .get(HttpUtils.getBaseUrl() + '/hybridity/api/directConnects')
    .map(
        (res: any) => this.value = res
      );
  }

  getVDCsList() {
    return this.http
    .get(HttpUtils.getBaseUrl() + '/hybridity/api/vdcNetworks')
    .map(
        (res: any) => this.value = res
      );
  }

  /* Gateway APIs */
  getGatewaysList() {
    return this.http
      .get(HttpUtils.getBaseUrl() + '/hybridity/api/gateways')
      .map(
      (res: any) => this.value = res
      );
  }

  getAllVDCs() {
    return this.http
      .get(HttpUtils.getBaseUrl() + '/hybridity/api/virtualdcs')
      .map(
      (res: any) => this.value = res
      );
  }

  // returns all external networks observer, it notifies if external network array is changed
  get externalNetworks() {
    return this._externalNetworks$.asObservable();
  }

  getAllExternalNetworks() {
    return this.http
      .get(HttpUtils.getBaseUrl() + '/hybridity/api/externalNetworks')
      .subscribe(
        (networks:any) => {
          this.dataStore.externalNetworks = networks.map(network => {
              return {
                  'name': network.name,
                  'objectId': network.objectId,
                  'freeIpCount':  network.freeIpCount,
                  'availableVdcs': network.availableVdcs
              };
          });
          this._externalNetworks$.next(this.dataStore.externalNetworks);
        },
        error => {
          this.dataStore.externalNetworks = [];
          this._externalNetworks$.next(this.dataStore.externalNetworks);
        }
      );
  }

  createGateway(gateway) {
    let url = '/hybridity/api/vdc/' + gateway.vdcId + '/gateways';
    return this.http
      .post(url, JSON.stringify(gateway))
      .map(
      (res: any) => this.value = res
      );
  }

  updateGateway(gateway) {
    let url = '/hybridity/api/vdc/' + gateway.vdcId + '/gateways/' + gateway.objectId;
    return this.http
      .put(url, JSON.stringify(gateway))
      .map(
      (res: any) => this.value = res
      );
  }

  deleteGateway(gateway) {
    let url = '/hybridity/api/vdc/' + gateway.vdcId + '/gateways/' + gateway.objectId;
    return this.http
      .delete(url)
      .map(
      (res: any) => this.value = res
      );
  }

  logError(error, origin:String = '') {
    console.error('Error: ', error, (origin !== '')? " Error from " + origin : "");
  }

  logOperationCompleted(msg: string) {
    console.log('Operation Completed: ', msg)
  }

  processData(dcList) {
  let data: {};
  let maskBits: any;
  let ipRanges: any;
  let netmask: string;
  let gatewayAddress: any;
  let dcProcessedData = [];
  for (let i = 0; i < dcList.length; i++ ) {
      let directConnect = dcList[i];
      let name = directConnect.directConnectConfiguration.name;
      let description = directConnect.directConnectConfiguration.description;

      let subnets = (directConnect.subnets) ? directConnect.subnets : [];
      let arrSubnets: Array<any> = [];
      for (let j = 0; j < subnets.length; j++) {
        let subnet = {
            gatewayAddress: subnets[j].gatewayAddress,
            ipRanges: $.extend(true, [],  subnets[j].ipRanges),
            maskBits: subnets[j].maskBits,
            netmask: subnets[j].netmask,
        }
        arrSubnets.push (subnet);
      }

      let networkId = (directConnect.network && directConnect.network.id) ? directConnect.network.id : "";
      let edgesConnected = (directConnect.edgesConnected) ? directConnect.edgesConnected : [];
      let arrEdgesConnected: Array<any> = [];
      for (let k = 0; k < edgesConnected.length; k++) {

        let gatewayInterfaces = edgesConnected[k].gatewayInterfaces;

        for (let m = 0; m < gatewayInterfaces.length; m++) {

          if (gatewayInterfaces[m].networkId === networkId) {
              gatewayAddress = gatewayInterfaces[m].subnets[0].gatewayAddress;
              ipRanges = gatewayInterfaces[m].subnets[0].ipRanges;
              maskBits = gatewayInterfaces[m].subnets[0].maskBits;
              netmask = gatewayInterfaces[m].subnets[0].netmask;
          }
        }
        let edge = {
            name: edgesConnected[k].name,
            id: edgesConnected[k].id,
            ipRanges: $.extend(true, [], ipRanges),
            maskBits: maskBits,
            netmask: netmask,
            gatewayAddress: gatewayAddress,
            gatewayInterfaces: gatewayInterfaces

        };
        arrEdgesConnected.push (edge);
      }

      data = {
        name: name,
        description: description,
        subnets: arrSubnets,
        edgesConnected: arrEdgesConnected,
        rawData: directConnect
      };
      dcProcessedData.push (data);
    }
    return dcProcessedData;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/network/network.service.ts